import { TSeller } from "./seller";

export const ADMIN_ROLE = "Super Admin";
export type TSupplierCommercial = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  roleId: string;
  supplierId: string;
  referralCode?: string;
  warehouseId?: string;
  warehouseIds?: string[];
  status: boolean;
  categoryIds: string[];
  brandIds?: string[];
  segmentIds?: string[];
  assignedUserIds?: string[];
  password?: string | null;
};

export type TSupplierPermission = {
  id?: string;
  name: string;
  description: string;
  key: string;
};

export type TSupplierRole = {
  id: string;
  name: string;
  description: string;
  key: string;
  supplierId: string;
  permissions: string[];
};

export type TSupplierCommercialVisit = {
  id: number;
  supplierId: string;
  commercialId: string;
  clientId: string;
  latitude?: string | null;
  longitude?: string | null;
  description?: string | null;
  evidence?: string | null;
  createdAt: string;
  client?: TSeller;
};
